import AboutUs from "../components/home/AboutUs";
import BlogPost from "../components/home/BlogPost";
import Capabilities from "../components/home/Capabilities";
import Client from "../components/home/Clients";
import Intro from "../components/home/Intor";
import OurTeam from "../components/home/OurTeam";
import ProjectCarousel from "../components/home/ProjectCarousel";
import WhyUs from "../components/home/WhyUs";
import Testimonials from "../components/home/Testimonials";
import WorkProcess from "../components/home/WorkProcess";
import Industries from "../components/home/Industries";
import { getHome } from "../api/homeApi";
import React, { useEffect, useState, useRef } from "react";
import _ from "../lib/loadlash";
import Loader from "../components/Loader";

const Home = () => {
  const capabilitiesRef = useRef(null);
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);
      const { data, errors } = await getHome();
      setLoading(false);
      if (!_.isEmpty(errors)) {
        console.error("Error fetching home data:", errors);
        return;
      }
      setContent(data?.data);
    };

    fetchContent();
  }, []);
  console.log("Home content:", content);
  return (
    <div style={{ background: "white" }}>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Intro
            scrollToCapabilities={() =>
              capabilitiesRef.current?.scrollIntoView({ behavior: "smooth" })
            }
            content={content?.Intro}
          />
          <ProjectCarousel content={content?.Projects} />
          <AboutUs content={content?.AboutUs} />
          {/* //btn rem */}
          <Client content={content?.Companies} />
          <WhyUs content={content?.WhyUs} />
          <Capabilities ref={capabilitiesRef} content={content?.Capabilities} />
          <Industries content={content?.Industries} />
          <Testimonials content={content?.Testimonials} />
          <WorkProcess content={content?.WorkProcess} />
          <OurTeam content={content?.Team} />
          {/* <BlogPost /> */}
        </>
      )}
    </div>
  );
};
export default Home;
